import * as React from 'react';
import styles from './Labels.module.scss';
import type * as Types from '@/stores/productsApiTypes';

export const Labels = ({ labels = [] }: { labels: Types.Attribute[] }) => {
  return (
    <div className={styles.Labels}>
      {labels.map((label) => {
        return (
          <span className={`${styles.Label} ${styles[`_${label.code}`]} mb-2`} key={label.code}>
            {label.value}
          </span>
        );
      })}
    </div>
  );
};
